/**
 * text.js — text sanitisation helpers.
 */

/**
 * Replaces stray Unicode replacement characters (U+FFFD, rendered as a black
 * diamond or "?") with a non-breaking space (U+00A0).
 *
 * Some staging product descriptions were imported through a process that
 * mishandled encoding, turning the original non-breaking spaces (U+00A0) into
 * U+FFFD. This restores the intended spacing for display only — it does NOT
 * touch clean content (no U+FFFD -> returned unchanged) and is a safe no-op for
 * non-string values (null/undefined/etc.). A non-breaking space is used so the
 * gap does not collapse in HTML, matching how the spacing appears on live.
 *
 * Unicode escapes are used (not literal characters) so the rule never depends
 * on this file's own encoding.
 *
 * NOTE: stopgap for the staging data artifact — the permanent fix is to clean
 * the source data so the encoding isn't corrupted on import/sync.
 *
 * @param {*} value
 * @returns {*} sanitised string, or the original value if not a string
 */
export const sanitizeText = (value) =>
  typeof value === 'string' ? value.replace(/\uFFFD/g, '\u00A0') : value;

export default sanitizeText;
